export default "__VITE_ASSET__B9IPSz1f__"